module.exports = __webpack_public_path__ + "img/img_pocket_flower.bb2b5192.png";